import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

export default function Unauthorized() {
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center gap-5 text-center">
      <Seo title="Access Denied" />
      <div className="text-6xl">🔒</div>
      <h1 className="heading-brand text-3xl">Access Denied</h1>
      <p className="max-w-md text-ink-muted">
        You don't have permission to view this page. If you believe this is an error, contact an
        administrator.
      </p>
      <div className="flex gap-3">
        <Link to="/" className="btn-primary">
          Go home
        </Link>
        <Link to="/login" className="btn-outline">
          Sign in
        </Link>
      </div>
    </div>
  );
}
